/**
 * * This file was automatically generated by react-scripts-trackman codegen.
 * * YOU ARE FREE TO MODIFY IT AS NEEDED.
 * * The only thing you should not modify is this very comment.
 * * The list below is used to generate new hooks based on their name.
 * * When new hook name is not found in the list, it will be generated
 * * and appended at the end of the file.
 * *
 * * Previously generated hooks (DO NOT MODIFY): [useGetDashboard, useGetDashboardReports, useGetDashboardReportTypes]
 */

import { ReportItemDto } from 'types/CodegenDashboardTypes';
import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useStores } from 'index';

export const useGetDashboardReports = () => {
  const codegenDashboardService = useStores().codegenDashboardService;

  const select = useCallback((data: ReportItemDto[]) => data.map((report) => ({ ...report, id: report.reportId })), []);

  return useQuery({
    queryKey: ['getDashboardReports'],
    queryFn: () => codegenDashboardService.getDashboardReports(),
    select,
  });
};
